import querystring from "querystring";

export const parseHash = () => {
  const hash = window.location.hash.substr(1);
  return querystring.parse(hash);
};

export const convertObjToBase64 = (obj) => {
  return btoa(JSON.stringify(obj));
};
